module.exports = __webpack_public_path__ + "static/gallery-80939b753d1431b0cb78009a31706222.jpg";